import React from "react";
import PropTypes from "prop-types";
import {Card, Col} from "react-bootstrap";

const CustomCard = (props) => {
    return (
        <>
            <Col md={props.width ? props.width : 12} className={props.className}>
                {props.underCard}
                <Card
                    className={` ${props.withoutPadding ? "" : "mb-3 "} ${props.shadow === false ? "" : "shadow"} ${props.className}`}>
                    {!props.withoutHeader &&
                        <Card.Header
                            onClick={() => {
                                if (props.onClick) {
                                    props.onClick();
                                }
                            }}
                            className={(props.withoutPadding ? "card-header-small" : "py-3 ")
                                + (props.onClick ? "cursor-pointer btn  card-header-clickable " : "")
                                + (props.onClick ? (props.active ? " btn-primary " : " btn-outline-primary ") : "")
                            }>
                            {props.titleComponent && props.titleComponent}
                            {!props.titleComponent && <p className="m-0 font-weight-bold">{props.title}</p>}

                        </Card.Header>
                    }
                    {props.children && !props.hideBody &&
                        <Card.Body>
                            {props.children}
                        </Card.Body>
                    }
                </Card>
            </Col>
        </>
    );
};

// Define PropTypes
CustomCard.propTypes = {
    width: PropTypes.number, // Optional width of the column (e.g., 12 for full-width)
    className: PropTypes.string, // CSS class names for styling
    underCard: PropTypes.node, // Content to display above the Card
    withoutPadding: PropTypes.bool, // To remove padding from the card
    shadow: PropTypes.bool, // Determines whether to show shadow or not
    withoutHeader: PropTypes.bool, // If true, the header is hidden
    onClick: PropTypes.func, // Function to handle clicks on the card header
    active: PropTypes.bool, // Active state to toggle styling (e.g., btn-primary)
    title: PropTypes.string, // Title text for the card, required
    children: PropTypes.node, // Any children to render inside the card body
    hideBody: PropTypes.bool, // If true, hides the body content of the card
};

export default CustomCard;
